import { V2Drawer } from '@abyss/web/ui/Drawer';
import { IconSymbol } from '@abyss/web/ui/IconSymbol';
import { Layout } from '@abyss/web/ui/Layout';
import { Link } from '@abyss/web/ui/Link';
import { Text } from '@abyss/web/ui/Text';
import { t } from 'i18next';
import { find } from 'lodash';

import { ConstantsLagoon } from '../../../../common/ConstantsLagoon';
import { useLagoon } from '../../../../hooks/useLagoon';

interface MedicalVisionDrawerProps {
  isOpen: boolean;
  onClose: () => void;
}

export const MedicalVisionDrawer = ({
  isOpen,
  onClose,
}: MedicalVisionDrawerProps) => {
  const uiMessaging = useLagoon('ui-messaging')();

  const medicalVsVisionFlyoutNotice = find(uiMessaging, {
    key: ConstantsLagoon.MIXED_SEARCH_RESULT_PAGE
      .MEDICAL_VS_VISION_FLYOUT_NOTICE,
  })?.message;

  const medicalFlyoutMessaging = find(uiMessaging, {
    key: ConstantsLagoon.MIXED_SEARCH_RESULT_PAGE
      .MEDICAL_VS_VISION_FLYOUT_MEDICAL_DESCRIPTION,
  });

  const medicalFlyoutDescriptionTitle = medicalFlyoutMessaging?.title;

  const medicalFlyoutDescription = medicalFlyoutMessaging?.message;

  const visionFlyoutMessaging = find(uiMessaging, {
    key: ConstantsLagoon.MIXED_SEARCH_RESULT_PAGE
      .MEDICAL_VS_VISION_FLYOUT_VISION_DESCRIPTION,
  });

  const visionFlyoutDescriptionTitle = visionFlyoutMessaging?.title;

  const visionFlyoutDescription = visionFlyoutMessaging?.message;

  const viewMedicalBenefits = find(uiMessaging, {
    key: ConstantsLagoon.MIXED_SEARCH_RESULT_PAGE.VIEW_MEDICAL_COVERAGE_CTA_URL,
  });

  const viewMedicalBenefitsText = viewMedicalBenefits?.message;

  const viewMedicalBenefitsUrl = viewMedicalBenefits?.url;

  const viewVisionBenefits = find(uiMessaging, {
    key: ConstantsLagoon.MIXED_SEARCH_RESULT_PAGE.VIEW_VISION_COVERAGE_CTA_URL,
  });

  const viewVisionBenefitsText = viewVisionBenefits?.message;

  const viewVisionBenefitsUrl = viewVisionBenefits?.url;

  return (
    <V2Drawer
      css={{
        'abyss-modal-base-header-container': {
          padding: '16px',
        },
      }}
      data-auto-testid="medical-vs-vision-drawer"
      data-testid="medical-vs-vision-drawer"
      header={t('MEDICAL_SPECIALISTS_VS_VISION.Medical_Specialists_vs_Vision')}
      isOpen={isOpen}
      onClose={onClose}
    >
      <Layout.Stack space={24}>
        <Layout.Stack alignItems="left">
          <Text fontWeight={700}>{medicalFlyoutDescriptionTitle}</Text>
          <Text>{medicalFlyoutDescription}</Text>
          <Link
            after={<IconSymbol icon="chevron_right" size={'20px'} />}
            data-auto-testid="medical-benefits-link"
            data-testid="medical-benefits-link"
            hideIcon={true}
            href={viewMedicalBenefitsUrl}
            openNewWindow={false}
          >
            {viewMedicalBenefitsText}
          </Link>
        </Layout.Stack>
        <Layout.Stack alignItems="left">
          <Text fontWeight={700}>{visionFlyoutDescriptionTitle}</Text>
          <Text>{visionFlyoutDescription}</Text>
          <Link
            after={<IconSymbol icon="chevron_right" size={'20px'} />}
            data-auto-testid="vision-benefits-link"
            data-testid="vision-benefits-link"
            hideIcon={true}
            href={viewVisionBenefitsUrl}
            openNewWindow={false}
          >
            {viewVisionBenefitsText}
          </Link>
        </Layout.Stack>
        <Text>{medicalVsVisionFlyoutNotice}</Text>
      </Layout.Stack>
    </V2Drawer>
  );
};
